<template>
	<div class="team-detail-contact">
		<p class="col-lg-9 mb-5">
			{{ contact.SpeakerText }}
		</p>
		<h5>Get in Touch!</h5>
		<ul class="list-unstyled contact-data">
			<div class="contact-data-flex">
				<li v-if="contact.Email">
					<font-awesome-icon :icon="['custom', 'mail']" />
					<a :href="emailHref">{{ obfuscatedEmail }}</a>
				</li>
				<li v-if="contact.Phone">
					<font-awesome-icon :icon="['custom', 'phone']" />
					<a :href="`tel:${contact.Phone}`">{{ contact.Phone }}</a>
				</li>
			</div>
			<li v-if="contact.VCard">
				<font-awesome-icon :icon="['custom', 'download']" />
				<a :href="contact.VCard" download target="_blank" rel="noopener"
					>vCard</a
				>
			</li>
			<li v-if="contact.Downloads && contact.Downloads.length">
				<font-awesome-icon :icon="['custom', 'pdf']" />
				<a
					:href="completePDFUrl(contact.Downloads[0].url)"
					download
					target="_blank"
					rel="noopener"
					>PDF Download</a
				>
			</li>
		</ul>
		<SocialMedia :contact="contact" />
	</div>
</template>

<script>
import SocialMedia from './SocialMedia'
export default {
	name: 'TeamDetailGetinTouch',
	components: {
		SocialMedia
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact'],
	data() {
		return {
			contactEmail: 'booking@cromatics.de'
		}
	},
	computed: {
		obfuscatedEmail() {
			return this.contactEmail.replace('@', ' [at] ').replace('.', ' [dot] ')
		},
		emailHref() {
			return `mailto:${this.contactEmail}`
		}
	},
	methods: {
		completePDFUrl(pdfPath) {
			return `${this.$config.pimcoreUrl}${pdfPath}`
		}
	}
}
</script>

<style lang="scss">
.team-detail-contact {
	.contact-data {
		li {
			display: flex;
			align-items: center;
			gap: 20px;
			margin-bottom: 1rem;
			a {
				color: $white;
				&:hover {
					color: $green;
				}
			}
			[data-icon='pdf'] {
				font-size: 1.5rem;
			}
		}
	}
	.contact-social {
		display: flex;
		align-items: center;
		gap: 20px;
		li {
			a {
				color: $white;
				&:hover {
					color: $green;
				}
			}
		}
	}
}
</style>
